// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var API = require("../reason/common/API.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReasonPromise = require("../reason/ReasonPromise.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var AuthSessionUserIdQuery_graphql = require("../__generated__/AuthSessionUserIdQuery_graphql.bs.js");
var AuthSessionUserRoleQuery_graphql = require("../__generated__/AuthSessionUserRoleQuery_graphql.bs.js");

var useCurrentAuthSession_ = {
  contents: (function () {
      
    })
};

var getWithExpiryCheck_ = {
  contents: (async function (param) {
      
    })
};

var logout_ = {
  contents: (async function () {
      
    })
};

var loginSuccess_ = {
  contents: (function (param) {
      
    })
};

var createSession_ = {
  contents: (async function () {
      
    })
};

var Internal = {
  useCurrentAuthSession_: useCurrentAuthSession_,
  getWithExpiryCheck_: getWithExpiryCheck_,
  logout_: logout_,
  loginSuccess_: loginSuccess_,
  createSession_: createSession_
};

function use() {
  return useCurrentAuthSession_.contents();
}

function getWithExpiryCheck(operationName) {
  return getWithExpiryCheck_.contents(operationName);
}

function logout() {
  return logout_.contents();
}

function createSession() {
  return createSession_.contents();
}

var convertVariables = AuthSessionUserIdQuery_graphql.Internal.convertVariables;

var convertResponse = AuthSessionUserIdQuery_graphql.Internal.convertResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables, AuthSessionUserIdQuery_graphql.node, convertResponse);

RescriptRelay_Query.useLoader(convertVariables, AuthSessionUserIdQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(AuthSessionUserIdQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(AuthSessionUserIdQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.fetchPromised(AuthSessionUserIdQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(AuthSessionUserIdQuery_graphql.node, convertVariables);

function useCurrentUserId() {
  var data = use$1(undefined, "store-only", undefined, undefined);
  var match = data.currentAuthSession;
  if (match !== undefined && match.__typename === "AuthSession") {
    return match.user.id;
  }
  
}

function useIsLoggedIn() {
  return Core__Option.isSome(useCurrentUserId());
}

var convertVariables$1 = AuthSessionUserRoleQuery_graphql.Internal.convertVariables;

var convertResponse$1 = AuthSessionUserRoleQuery_graphql.Internal.convertResponse;

var use$2 = RescriptRelay_Query.useQuery(convertVariables$1, AuthSessionUserRoleQuery_graphql.node, convertResponse$1);

RescriptRelay_Query.useLoader(convertVariables$1, AuthSessionUserRoleQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(AuthSessionUserRoleQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(AuthSessionUserRoleQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.fetchPromised(AuthSessionUserRoleQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.retain(AuthSessionUserRoleQuery_graphql.node, convertVariables$1);

function useCurrentUserRole() {
  var data = use$2(undefined, "store-only", undefined, undefined);
  var match = data.currentAuthSession;
  if (match !== undefined && match.__typename === "AuthSession") {
    return match.user.role;
  }
  
}

function login(email, password, rememberMeOpt) {
  var rememberMe = rememberMeOpt !== undefined ? rememberMeOpt : false;
  return ReasonPromise.Js.toBsPromise(ReasonPromise.map(API.login(email, password, rememberMe), (function (x) {
                    if (x.TAG !== "Ok") {
                      return {
                              TAG: "Error",
                              _0: x._0
                            };
                    }
                    var data = x._0;
                    loginSuccess_.contents(data);
                    return {
                            TAG: "Ok",
                            _0: data
                          };
                  })));
}

function useIsImpersonated() {
  var authSession = use();
  if (authSession !== undefined && authSession.__typename === "AuthSession") {
    return authSession.isImpersonated;
  } else {
    return false;
  }
}

function useAgentIsCurrentUser(agentId) {
  var authSession = use();
  if (authSession === undefined) {
    return false;
  }
  if (authSession.__typename !== "AuthSession") {
    return false;
  }
  var match = authSession.user;
  if (match.role === "AGENT" && agentId !== undefined) {
    return match.id === agentId;
  } else {
    return false;
  }
}

exports.Internal = Internal;
exports.use = use;
exports.getWithExpiryCheck = getWithExpiryCheck;
exports.logout = logout;
exports.createSession = createSession;
exports.useCurrentUserId = useCurrentUserId;
exports.useIsLoggedIn = useIsLoggedIn;
exports.useCurrentUserRole = useCurrentUserRole;
exports.login = login;
exports.useIsImpersonated = useIsImpersonated;
exports.useAgentIsCurrentUser = useAgentIsCurrentUser;
/* use Not a pure module */
